import { z } from "zod/v4";

export const userSchema = z.object({
  id: z.string(),
  email: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
});

export type User = z.infer<typeof userSchema>;
